// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"05f05574","812":"ef3c4d72","823":"87719b4d"}[chunkId] + ".chunk.js";
};